/** Generated by scripts/update-map-index.ts; tests enforce parity with dailyMaps. */
export const mapIndex: Record<
  string,
  {
    storageKey: string;
    finalStage: number;
    placeIds: string[];
    title: string;
    unit: string;
    preview: string;
  }
> = {
  '2026-09-26': {
    storageKey: 'mentat.maps.v1:2026-10-26:east-africa',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Eastern Africa and the Great Lakes',
    unit: 'countries',
    preview: '/map-previews/east-africa.svg',
  },
  '2026-09-27': {
    storageKey: 'mentat.maps.v1:2026-10-27:west-africa-coast',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'West Africa · coast and inland neighbors',
    unit: 'countries',
    preview: '/map-previews/west-africa-coast.svg',
  },
  '2026-09-28': {
    storageKey: 'mentat.maps.v1:2026-09-27:east',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Eastern United States',
    unit: 'states',
    preview: '/map-previews/east.svg',
  },
  '2026-09-29': {
    storageKey: 'mentat.maps.v1:2026-09-25:west',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Western United States',
    unit: 'states',
    preview: '/map-previews/west.svg',
  },
  '2026-09-30': {
    storageKey: 'mentat.maps.v1:2026-09-26:europe',
    finalStage: 4,
    placeIds: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
    ],
    title: 'Europe',
    unit: 'countries',
    preview: '/map-previews/europe.svg',
  },
  '2026-10-01': {
    storageKey: 'mentat.maps.v1:2026-09-28:south-america',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'South America',
    unit: 'countries',
    preview: '/map-previews/south-america.svg',
  },
  '2026-10-02': {
    storageKey: 'mentat.maps.v1:2026-09-29:north-africa',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'North Africa & the Sahel',
    unit: 'countries',
    preview: '/map-previews/north-africa.svg',
  },
  '2026-10-03': {
    storageKey: 'mentat.maps.v1:2026-09-30:southern-states',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Southern United States',
    unit: 'states',
    preview: '/map-previews/southern-states.svg',
  },
  '2026-10-04': {
    storageKey: 'mentat.maps.v1:2026-10-01:lower-manhattan-local-v2',
    finalStage: 3,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
    title: 'Lower Manhattan',
    unit: 'areas',
    preview: '/map-previews/lower-manhattan-local-v2.svg',
  },
  '2026-10-05': {
    storageKey: 'mentat.maps.v1:2026-10-02:south-bay',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Los Angeles · South Bay',
    unit: 'cities',
    preview: '/map-previews/south-bay.svg',
  },
  '2026-10-06': {
    storageKey: 'mentat.maps.v1:2026-10-03:north-brooklyn-local-v2',
    finalStage: 3,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
    title: 'Northern Brooklyn',
    unit: 'areas',
    preview: '/map-previews/north-brooklyn-local-v2.svg',
  },
  '2026-10-07': {
    storageKey: 'mentat.maps.v1:2026-10-04:plains-lakes',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Plains to Great Lakes',
    unit: 'states',
    preview: '/map-previews/plains-lakes.svg',
  },
  '2026-10-08': {
    storageKey: 'mentat.maps.v1:2026-10-05:upper-manhattan-neighborhoods',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Upper Manhattan',
    unit: 'areas',
    preview: '/map-previews/upper-manhattan-neighborhoods.svg',
  },
  '2026-10-09': {
    storageKey: 'mentat.maps.v1:2026-10-06:gateway-cities',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Los Angeles · Gateway cities',
    unit: 'cities',
    preview: '/map-previews/gateway-cities.svg',
  },
  '2026-10-10': {
    storageKey: 'mentat.maps.v1:2026-10-07:northeast-states',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Northeast & Appalachia',
    unit: 'states',
    preview: '/map-previews/northeast-states.svg',
  },
  '2026-10-11': {
    storageKey: 'mentat.maps.v1:2026-10-08:western-queens-neighborhoods',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Western Queens',
    unit: 'neighborhoods',
    preview: '/map-previews/western-queens-neighborhoods.svg',
  },
  '2026-10-12': {
    storageKey: 'mentat.maps.v1:2026-10-09:southern-africa',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Southern Africa',
    unit: 'countries',
    preview: '/map-previews/southern-africa.svg',
  },
  '2026-10-13': {
    storageKey: 'mentat.maps.v1:2026-10-10:south-central-bronx-neighborhoods',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Southern & central Bronx',
    unit: 'neighborhoods',
    preview: '/map-previews/south-central-bronx-neighborhoods.svg',
  },
  '2026-10-14': {
    storageKey: 'mentat.maps.v1:2026-10-11:san-gabriel-cities',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Los Angeles · San Gabriel Valley',
    unit: 'cities',
    preview: '/map-previews/san-gabriel-cities.svg',
  },
  '2026-10-15': {
    storageKey: 'mentat.maps.v1:2026-10-12:great-lakes-ohio',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Great Lakes & Ohio Valley',
    unit: 'states',
    preview: '/map-previews/great-lakes-ohio.svg',
  },
  '2026-10-16': {
    storageKey: 'mentat.maps.v1:2026-10-13:south-brooklyn-neighborhoods',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Southern Brooklyn',
    unit: 'neighborhoods',
    preview: '/map-previews/south-brooklyn-neighborhoods.svg',
  },
  '2026-10-17': {
    storageKey: 'mentat.maps.v1:2026-10-14:south-southeast-asia',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'South & Southeast Asia',
    unit: 'countries',
    preview: '/map-previews/south-southeast-asia.svg',
  },
  '2026-10-18': {
    storageKey: 'mentat.maps.v1:2026-10-18:midtown-manhattan-local-v2',
    finalStage: 3,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
    title: 'Midtown Manhattan and neighboring areas',
    unit: 'areas',
    preview: '/map-previews/midtown-manhattan-local-v2.svg',
  },
  '2026-10-19': {
    storageKey: 'mentat.maps.v1:2026-10-19:eastern-san-gabriel',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Los Angeles · eastern San Gabriel Valley',
    unit: 'cities',
    preview: '/map-previews/eastern-san-gabriel.svg',
  },
  '2026-10-20': {
    storageKey: 'mentat.maps.v1:2026-10-20:rockies-plains',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Rockies and southern Plains',
    unit: 'states',
    preview: '/map-previews/rockies-plains.svg',
  },
  '2026-10-21': {
    storageKey: 'mentat.maps.v1:2026-10-21:central-queens-neighborhoods',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Central Queens',
    unit: 'neighborhoods',
    preview: '/map-previews/central-queens-neighborhoods.svg',
  },
  '2026-10-22': {
    storageKey: 'mentat.maps.v1:2026-10-22:balkan-region',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Balkans and neighboring countries',
    unit: 'countries',
    preview: '/map-previews/balkan-region.svg',
  },
  '2026-10-23': {
    storageKey: 'mentat.maps.v1:2026-10-23:eastern-bronx-neighborhoods',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Eastern Bronx',
    unit: 'neighborhoods',
    preview: '/map-previews/eastern-bronx-neighborhoods.svg',
  },
  '2026-10-24': {
    storageKey: 'mentat.maps.v1:2026-10-24:new-england-neighbors',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'New England and the Mid-Atlantic',
    unit: 'states',
    preview: '/map-previews/new-england-neighbors.svg',
  },
  '2026-10-25': {
    storageKey: 'mentat.maps.v1:2026-10-25:southeast-queens-neighborhoods',
    finalStage: 2,
    placeIds: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    title: 'Southeastern Queens',
    unit: 'neighborhoods',
    preview: '/map-previews/southeast-queens-neighborhoods.svg',
  },
};
